'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002411 from "./presto.-Agent-View$$anon$11.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$10() {
  this.avO = null;
  this.avG = null;
  this.avH = false;
  this.avP = null;
  this.avQ = false;
  this.avT = null;
  this.avM = null;
  this.avN = false;
  this.avI = null;
  this.avJ = false;
  this.avK = null;
  this.avL = false;
  this.avR = false;
  this.avS = false;
  this.avO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.avT = "Error";
}
export { $c_Lpresto_AgentView$$anon$10 as $c_Lpresto_AgentView$$anon$10 };
$p = $c_Lpresto_AgentView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$10;
/** @constructor */
function $h_Lpresto_AgentView$$anon$10() {
}
export { $h_Lpresto_AgentView$$anon$10 as $h_Lpresto_AgentView$$anon$10 };
$h_Lpresto_AgentView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.avO;
});
$p.L = (function() {
  if ((!this.avH)) {
    this.avG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avH = true;
  }
  return this.avG;
});
$p.O = (function() {
  if ((!this.avQ)) {
    this.avP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.avQ = true;
  }
  return this.avP;
});
$p.E = (function() {
  return this.avT;
});
$p.t = (function() {
  if ((!this.avN)) {
    this.avM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avN = true;
  }
  return this.avM;
});
$p.M = (function() {
  if ((!this.avJ)) {
    this.avI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avJ = true;
  }
  return this.avI;
});
$p.Q = (function() {
  if ((!this.avL)) {
    this.avK = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002411.$c_Lpresto_AgentView$$anon$11();
    this.avL = true;
  }
  return this.avK;
});
$p.w = (function() {
  if ((!this.avS)) {
    this.avR = false;
    this.avS = true;
  }
  return this.avR;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee71) => ((p) => \u03b4scrutinee71))($j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$())));
});
var $d_Lpresto_AgentView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$10, "presto.AgentView$$anon$10", ({
  Dz: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$10 as $d_Lpresto_AgentView$$anon$10 };
//# sourceMappingURL=presto.-Agent-View$$anon$10.js.map
